<div class="logo-container">
	<img src="assets/images/amcn-mdm-logo.svg" alt="AMC" class="logo" />
</div>

<div class="page-name">
	{{ selectedSubPage?.name || selectedPage?.name }}
</div>

<div class="main-filters"><ng-content></ng-content></div>
<div class="menu">
	<button *ngIf="!DataStorageHelper.isPortal()" class="item" mat-button [matMenuTriggerFor]="menu">
		<amc-iconify icon="account" size="l"></amc-iconify>
	</button>

	<mat-menu #menu="matMenu" class="user-menu">
		<button mat-menu-item disabled class="user-name" (click)="$event.preventDefault(); $event.stopPropagation()">
			{{ userName }}
		</button>
		<button mat-menu-item class="logout-container" (click)="logout()">
			<amc-iconify icon="logout" size="s"></amc-iconify> Logout
		</button>
	</mat-menu>
</div>
